import { openUrlInSystemBrowser } from "@/lib/mail/openExternalUrl";
import { isMobileMailViewport } from "@/lib/device/isMobileMail";

/** iOS / iPadOS ne rend pas les PDF dans iframe/embed avec blob: ni toujours https inline. */
export function isMobilePdfInlineUnsupported(): boolean {
  if (typeof navigator === "undefined") return true;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/i.test(ua)) return true;
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) return true;
  return false;
}

/** PDF mobile : pas d’iframe blob — ouverture lecteur natif ou embed Android. */
export function shouldUseMobilePdfShell(): boolean {
  return isMobileMailViewport();
}

export function openUrlInNewTab(url: string): void {
  openUrlInSystemBrowser(url);
}

function pdfFilename(name: string): string {
  const trimmed = name.trim() || "document.pdf";
  return trimmed.toLowerCase().endsWith(".pdf") ? trimmed : `${trimmed}.pdf`;
}

function canSharePdfFile(file: File): boolean {
  return (
    typeof navigator !== "undefined" &&
    typeof navigator.share === "function" &&
    typeof navigator.canShare === "function" &&
    navigator.canShare({ files: [file] })
  );
}

function triggerBlobDownload(blobUrl: string, filename: string): void {
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * iOS PWA : `target=_blank` + blob: est un no-op silencieux.
 * Share sheet (comme Chat) ouvre le lecteur / Fichiers dans le geste utilisateur.
 */
export function openPdfBlobOnMobile(params: {
  blob: Blob;
  blobUrl: string;
  filename: string;
}): void {
  const filename = pdfFilename(params.filename);
  const file = new File([params.blob], filename, { type: "application/pdf" });

  if (canSharePdfFile(file)) {
    void navigator.share({ files: [file], title: filename }).catch((err: unknown) => {
      if (err instanceof Error && err.name === "AbortError") return;
      triggerBlobDownload(params.blobUrl, filename);
    });
    return;
  }

  triggerBlobDownload(params.blobUrl, filename);
}
